import React from "react";
import Nav from "../components/landing/Nav";
import Hero from "../components/landing/Hero";
import LeadMagnet from "../components/landing/LeadMagnet";
import PackagesBanner from "../components/landing/PackagesBanner";
import Pricing from "../components/landing/Pricing";
import WhoWeWorkWith from "../components/landing/WhoWeWorkWith";
import Topics from "../components/landing/Topics";
import About from "../components/landing/About";
import FAQ from "../components/landing/FAQ";
import Contact from "../components/landing/Contact";
import Footer from "../components/landing/Footer";
import FloatingCTA from "../components/landing/FloatingCTA";

export default function Landing() {
    return (
        <div className="min-h-screen bg-page text-ink" data-testid="landing-page">
            <Nav />
            <main>
                {/* Primary funnel: cold click from ManyChat → free download */}
                <Hero />
                <LeadMagnet />
                {/* Strong nudge into paid packages */}
                <PackagesBanner />
                <Pricing />
                {/* Deeper context for browsers who want to know more */}
                <WhoWeWorkWith />
                <Topics />
                <About />
                <FAQ />
                <Contact />
            </main>
            <Footer />
            <FloatingCTA />
        </div>
    );
}
